import getAuthData from "@/utils/getAuthData";
import axios from "axios";
import LambdaRequestParams from "@/entities/lambdaRequests/LambdaRequestParams";


export default async function lambdaRequest({
  lambdaName,
  requestData = {},
  method = "post",
}: LambdaRequestParams) {
  const uri = `${process.env.VUE_APP_LAMBDA}/${lambdaName}`;
  const { headers } = await getAuthData();

  try {
    const lambdaResponse = await axios(uri, {
      method,
      headers,
      data: requestData,
    });

    return lambdaResponse.data;
  } catch (error) {
    throw error.response.data;
  }
}

export { lambdaRequest };
